import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerButton: {
		id: 'native-issue-table.common.issue-cells.components.trigger-button',
		defaultMessage: 'See more components',
		description: 'Label for trigger button to open a dialog with a list of components',
	},
});
